document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".show-more a").forEach(showMore => {
        showMore.addEventListener("click", (e) => {
            const parent = showMore.dataset.parent;
            showMoreItems(parent, e.target);
        });
    });

    function showMoreItems(parent, showMoreLink) {
        const hiddenItems = document.querySelectorAll(`#${parent} .hidden-item`);
        const hiddenItemsArray = [...hiddenItems];
        hiddenItemsArray.forEach(hiddenItem => {
            hiddenItem.style.display = "list-item";
        });
        showMoreLink.parentNode.style.display = "none";
    }
});
